import { updateUserDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateUserCallable = getCallable(updateUserDefinition);
